import FormTrab from './FormTrab/FormTrab';
import FormFP from './FormFP/FormFP';

export const FormTrabPage = FormTrab;
export const FormFpZofri= FormFP;